import formatFileSize from './utils'

const messages = {
  after: (field, [target]) => `musi być po polu ${target}.`,
  alpha_dash: () =>
    `może zawierać litery, cyfry oraz myślnik lub podkreślnik.`,
  alpha_num: () => `może zawierać tylko litery i cyfry.`,
  alpha_spaces: () =>
    `może zawierać tylko litery oraz spacje.`,
  alpha: () => `może zawierać tylko litery.`,
  before: (field, [target]) => `musi być przed ${target}.`,
  between: (field, [min, max]) =>
    `musi być pomiędzy ${min} oraz ${max}.`,
  confirmed: (field, [confirmedField]) =>
    `nie zgadza się z polem potwierdzającym ${confirmedField}.`,
  date_between: (field, [min, max]) =>
    `musi zawierać się między ${min} a ${max}.`,
  date_format: (field, [format]) =>
    `musi pasować do formatu ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `musi być liczbą i może zawierać ${
      decimals === '*' ? '' : decimals
    } miejsca po przecinku.`,
  digits: (field, [length]) =>
    `musi być liczbą i dokładnie ${length} cyfr.`,
  dimensions: (field, [width, height]) =>
    `Obraz ${field} musi być szeroki na ${width} pikseli i wysoki na ${height} pikseli.`,
  email: () => `musi być poprawnym adresem email.`,
  ext: () => `musi być poprawnym plikiem.`,
  image: () => `musi być obrazem.`,
  in: () => `musi być poprawną wartością.`,
  ip: () => `musi być poprawnym adresem IP.`,
  max: (field, [length]) =>
    `nie może być dłuższe niż ${length} znaków.`,
  mimes: () => `musi posiadać poprawne rozszerzenie.`,
  min: (field, [length]) =>
    `musi być długie na co najmniej ${length} znaków.`,
  not_in: () => `musi być poprawną wartością.`,
  numeric: () => `może zawierać tylko cyfry.`,
  regex: () => `Format jest nieodpowiedni.`,
  required: () => `jest wymagane.`,
  size: (field, [size]) =>
    `musi być mniejszy niż ${formatFileSize(size)}.`,
  url: () => `nie jest poprawnym URL.`,
  fullName: () => 'jest niepoprawny (Imię, nazwisko i maks. 120 znaków)',
  emailInput: () => 'musi być poprawnym adresem email.',
  fullNamePerCountry: () => 'jest niepoprawny (Imię, nazwisko i maks. 18 znaków)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'pl',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/pl.js